import React, { createContext, useContext, ReactNode } from 'react';

interface FeatureFlags {
  crmEmailIntegration: boolean;
  dealPipeline: boolean;
  bulkEmail: boolean;
  contactImportExport: boolean;
  advancedSearch: boolean;
  documentEncryption: boolean;
  twoFactorAuth: boolean;
}

const defaultFlags: FeatureFlags = {
  crmEmailIntegration: true,
  dealPipeline: true,
  bulkEmail: true,
  contactImportExport: true,
  advancedSearch: true,
  documentEncryption: false, // Staged rollout
  twoFactorAuth: false // Staged rollout
};

const FeatureFlagsContext = createContext<FeatureFlags>(defaultFlags);

export const useFeatureFlags = () => useContext(FeatureFlagsContext);

interface FeatureFlagsProviderProps {
  children: ReactNode;
  flags?: Partial<FeatureFlags>;
}

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({ 
  children, 
  flags = {} 
}) => {
  const mergedFlags = { ...defaultFlags, ...flags };

  return (
    <FeatureFlagsContext.Provider value={mergedFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

interface FeatureGateProps {
  feature: keyof FeatureFlags;
  children: ReactNode;
  fallback?: ReactNode;
}

export const FeatureGate: React.FC<FeatureGateProps> = ({ 
  feature, 
  children, 
  fallback = null 
}) => {
  const flags = useFeatureFlags();
  
  return flags[feature] ? <>{children}</> : <>{fallback}</>;
};
